/* Maria Cooper Finds — Nordic theme interactions (v1.4) */
(function () {
  var MCF = window.MCF || { routes:{cart_add:'/cart/add.js',cart_change:'/cart/change.js',cart:'/cart'}, moneyFormat:'${{amount}}', cartDrawer:true, stickyAtc:true };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var fmt = MCF.moneyFormat || '${{amount}}';
    function withCommas(n){ return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withCommas(value);
        case 'amount_no_decimals': return withCommas((cents/100).toFixed(0));
        case 'amount_with_comma_separator': return withCommas(value).replace('.', ',').replace(/,(?=\d{3})/g,'.');
        default: return withCommas(value);
      }
    });
  }

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (t) { var n = document.getElementById('SiteNav'); if (n) n.classList.toggle('open'); }
  });

  /* ---------- generic quantity stepper (PDP / cart page) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var wrap = b.closest('.qty'); var i = wrap && wrap.querySelector('input'); if (!i) return;
    var v = parseInt(i.value, 10) || 1; v += b.getAttribute('data-qty') === 'up' ? 1 : -1; i.value = Math.max(1, v);
  });

  /* ---------- slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (s) {
    var slides = s.querySelectorAll('.slide'); if (slides.length < 2) return;
    var i = 0, dots = s.querySelectorAll('[data-dot]'), timer;
    function go(n) { slides[i].style.display = 'none'; if (dots[i]) dots[i].setAttribute('aria-current','false');
      i = (n + slides.length) % slides.length; slides[i].style.display = 'flex'; if (dots[i]) dots[i].setAttribute('aria-current','true'); }
    slides.forEach(function (sl, x) { sl.style.display = x === 0 ? 'flex' : 'none'; });
    dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); reset(); }); });
    function reset() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
    reset();
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function refreshDrawer(html) {
    if (!drawer || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cart-drawer-inner]');
    var live = drawer.querySelector('[data-cart-drawer-inner]');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }
  function updateCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && MCF.cartDrawer && drawer) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeLightbox(); } });

  /* line quantity change inside drawer */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]'); if (!b) return;
    e.preventDefault();
    var line = b.getAttribute('data-line'); var qty = b.getAttribute('data-value');
    fetch(MCF.routes.cart_change, {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: parseInt(line,10), quantity: parseInt(qty,10), sections:'cart-drawer' })
    }).then(function(r){return r.json();}).then(function(state){
      updateCount(state.item_count);
      if (state.sections && state.sections['cart-drawer']) refreshDrawer(state.sections['cart-drawer']);
    });
  });

  /* ---------- AJAX add to cart (PDP form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form], form[action*="/cart/add"]'); if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fetch(MCF.routes.cart_add, { method:'POST', headers:{'Accept':'application/json'}, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if (res.status) { /* error */ if (btn){btn.disabled=false; btn.textContent=btn.dataset.label||'Add to cart';} return; }
        return fetch(MCF.routes.cart + '.js').then(function(r){return r.json();}).then(function(cart){
          updateCount(cart.item_count);
          return fetch(MCF.routes.cart + '?section_id=cart-drawer').then(function(r){return r.text();}).then(refreshDrawer);
        });
      })
      .then(function(){ openDrawer(); })
      .catch(function(){})
      .finally(function(){ if (btn){ btn.disabled=false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  });

  function priceMarkup(v) {
    if (v.compare_at_price && v.compare_at_price > v.price)
      return '<span class="was">'+formatMoney(v.compare_at_price)+'</span><span class="sale">'+formatMoney(v.price)+'</span>';
    return formatMoney(v.price);
  }

  /* ---------- PDP gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]'); if (!t) return;
    var main = document.querySelector('[data-main-image]'); if (!main) return;
    main.src = t.getAttribute('data-full');
    main.alt = t.getAttribute('data-alt') || main.alt;
    if (t.getAttribute('data-zoom')) main.setAttribute('data-zoom', t.getAttribute('data-zoom'));
    document.querySelectorAll('[data-thumb].is-active').forEach(function (b) { b.classList.remove('is-active'); });
    t.classList.add('is-active');
  });

  /* ---------- PDP image lightbox: arrows, zoom, pan, touch ---------- */
  var lb = null, lbStage, lbImg, lbPrev, lbNext, lbCount;
  var lbItems = [], lbIndex = 0;
  var lbScale = 1, lbTx = 0, lbTy = 0;
  var lbPointers = new Map(), lbPinch = null, lbPinched = false;
  var lbDownX = 0, lbDownY = 0, lbStartTx = 0, lbStartTy = 0, lbMoved = false, lbDownTarget = null, lbLastTap = 0;

  function closeLightbox() { if (lb) { lb.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function lbApply() {
    lbImg.style.transform = 'translate(' + lbTx + 'px,' + lbTy + 'px) scale(' + lbScale + ')';
    lbStage.classList.toggle('is-zoomed', lbScale > 1);
  }
  function lbClamp() {
    var r = lbStage.getBoundingClientRect();
    var mx = Math.max(0, (lbImg.offsetWidth * lbScale - r.width) / 2);
    var my = Math.max(0, (lbImg.offsetHeight * lbScale - r.height) / 2);
    lbTx = Math.min(mx, Math.max(-mx, lbTx));
    lbTy = Math.min(my, Math.max(-my, lbTy));
  }
  function lbReset() { lbScale = 1; lbTx = 0; lbTy = 0; lbApply(); }
  function lbZoomTo(s, cx, cy) {
    var k = s / lbScale;
    lbTx = cx - k * (cx - lbTx);
    lbTy = cy - k * (cy - lbTy);
    lbScale = s; lbClamp(); lbApply();
  }
  function lbPoint(clientX, clientY) {
    var r = lbStage.getBoundingClientRect();
    return { x: clientX - r.left - r.width / 2, y: clientY - r.top - r.height / 2 };
  }
  function lbShow(i) {
    lbIndex = (i + lbItems.length) % lbItems.length;
    lbImg.src = lbItems[lbIndex].zoom;
    lbImg.alt = lbItems[lbIndex].alt;
    lbReset();
    var hide = lbItems.length > 1 ? '' : 'none';
    lbPrev.style.display = lbNext.style.display = lbCount.style.display = hide;
    lbCount.textContent = (lbIndex + 1) + ' / ' + lbItems.length;
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (thumbs[lbIndex] && !thumbs[lbIndex].classList.contains('is-active')) thumbs[lbIndex].click();
  }
  function lbBuild() {
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.innerHTML =
      '<div class="lightbox__stage"><img alt="" draggable="false"></div>' +
      '<button class="lightbox__close" aria-label="Close">&times;</button>' +
      '<button class="lightbox__nav lightbox__nav--prev" aria-label="Previous image">&#8249;</button>' +
      '<button class="lightbox__nav lightbox__nav--next" aria-label="Next image">&#8250;</button>' +
      '<div class="lightbox__count"></div>';
    document.body.appendChild(lb);
    lbStage = lb.querySelector('.lightbox__stage');
    lbImg = lbStage.querySelector('img');
    lbPrev = lb.querySelector('.lightbox__nav--prev');
    lbNext = lb.querySelector('.lightbox__nav--next');
    lbCount = lb.querySelector('.lightbox__count');

    lb.querySelector('.lightbox__close').addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });

    /* scroll wheel / trackpad zoom, centered on the cursor */
    lbStage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = lbPoint(e.clientX, e.clientY);
      lbZoomTo(Math.min(4, Math.max(1, lbScale * (e.deltaY < 0 ? 1.25 : 0.8))), p.x, p.y);
    }, { passive: false });

    /* unified mouse + touch: drag to pan, pinch to zoom, swipe to navigate, tap/double-tap */
    lbStage.addEventListener('pointerdown', function (e) {
      lbStage.setPointerCapture(e.pointerId);
      lbPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (lbPointers.size === 1) {
        lbPinched = false; lbMoved = false; lbDownTarget = e.target;
        lbDownX = e.clientX; lbDownY = e.clientY; lbStartTx = lbTx; lbStartTy = lbTy;
      } else if (lbPointers.size === 2) {
        lbPinched = true;
        var pts = Array.from(lbPointers.values());
        lbPinch = { d: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1, scale: lbScale };
      }
    });
    lbStage.addEventListener('pointermove', function (e) {
      if (!lbPointers.has(e.pointerId)) return;
      lbPointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (lbPointers.size === 2 && lbPinch) {
        var pts = Array.from(lbPointers.values());
        var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        var mid = lbPoint((pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
        lbZoomTo(Math.min(4, Math.max(1, lbPinch.scale * d / lbPinch.d)), mid.x, mid.y);
      } else if (lbPointers.size === 1) {
        var dx = e.clientX - lbDownX, dy = e.clientY - lbDownY;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) lbMoved = true;
        if (lbScale > 1) { lbTx = lbStartTx + dx; lbTy = lbStartTy + dy; lbClamp(); lbApply(); }
      }
    });
    function lbUp(e) {
      if (!lbPointers.has(e.pointerId)) return;
      lbPointers.delete(e.pointerId);
      if (lbPointers.size > 0) return;
      lbPinch = null;
      if (lbPinched || e.type === 'pointercancel') return;
      var dx = e.clientX - lbDownX, dy = e.clientY - lbDownY;
      /* touch swipe left/right changes image (only when not zoomed in; mouse uses arrows/keys) */
      if (e.pointerType !== 'mouse' && lbScale === 1 && Math.abs(dx) > 60 && Math.abs(dx) > 1.5 * Math.abs(dy)) {
        lbShow(dx < 0 ? lbIndex + 1 : lbIndex - 1);
        return;
      }
      if (!lbMoved) {
        if (lbDownTarget === lbImg) {
          if (e.pointerType === 'mouse') {
            /* desktop: single click toggles zoom at the cursor */
            if (lbScale > 1) lbReset();
            else { var p = lbPoint(e.clientX, e.clientY); lbZoomTo(2.5, p.x, p.y); }
          } else {
            /* touch: double-tap toggles zoom at that spot */
            var now = Date.now();
            if (now - lbLastTap < 350) {
              lbLastTap = 0;
              if (lbScale > 1) lbReset();
              else { var p2 = lbPoint(e.clientX, e.clientY); lbZoomTo(2.5, p2.x, p2.y); }
            } else { lbLastTap = now; }
          }
        } else {
          closeLightbox(); /* tap on the dark backdrop closes */
        }
      }
    }
    lbStage.addEventListener('pointerup', lbUp);
    lbStage.addEventListener('pointercancel', lbUp);
  }

  document.addEventListener('click', function (e) {
    var main = e.target.closest('[data-main-image]'); if (!main) return;
    var thumbs = document.querySelectorAll('[data-thumb]');
    lbItems = thumbs.length
      ? Array.prototype.map.call(thumbs, function (t) {
          return { zoom: t.getAttribute('data-zoom') || t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' };
        })
      : [{ zoom: main.getAttribute('data-zoom') || main.src, alt: main.alt || '' }];
    var start = 0;
    for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) { start = i; break; }
    if (!lb) lbBuild();
    lbShow(start);
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
    if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
  });

  /* ---------- product page variant selection ---------- */
  (function () {
    var form = document.querySelector('form[action*="/cart/add"][data-product-form]');
    if (!form) return;
    var data = form.querySelector('[data-product-variants]');
    var optionSelects = form.querySelectorAll('[data-product-option]');
    if (!data || !optionSelects.length) return; /* single-variant products need no wiring */
    var variants; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idField = form.querySelector('[data-product-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[type="submit"]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyBtn = document.querySelector('[data-sticky-add]');

    function setButton(btn, available) { if (btn) { btn.disabled = !available; btn.textContent = available ? 'Add to cart' : 'Sold out'; } }
    function update() {
      var chosen = [];
      optionSelects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-product-option'), 10)] = s.value; });
      var v = variants.find(function (variant) {
        var opts = variant.options || [variant.option1, variant.option2, variant.option3];
        return chosen.every(function (val, i) { return opts[i] === val; });
      });
      if (!v) { if (idField) idField.value = ''; setButton(addBtn, false); setButton(stickyBtn, false); return; }
      if (idField) idField.value = v.id;
      var markup = priceMarkup(v);
      if (priceEl) priceEl.innerHTML = markup;
      if (stickyPrice) stickyPrice.innerHTML = markup;
      setButton(addBtn, v.available); setButton(stickyBtn, v.available);
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  })();

  /* ---------- sticky add-to-cart bar ---------- */
  var bar = document.getElementById('StickyAtc');
  if (bar && MCF.stickyAtc) {
    var anchor = document.querySelector('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && en.boundingClientRect.top < 0) bar.classList.add('is-visible');
          else bar.classList.remove('is-visible');
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }
    bar.querySelector('[data-sticky-add]').addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click();
    });
  }
})();
